import { baseApi } from '@/lib/utils'

export interface ProfileResponse {
  success: boolean
  data: {
    name: string
    email: string
    created_at: string
    team_id: number | null
    team: string | null
    is_team_leader: boolean
    role: {
      name: string
      pages: string[]
    }
  }
}

export const profileApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getProfile: builder.query<ProfileResponse, void>({
      query: () => '/global/profile',
      providesTags: ['Profile'],
    }),
  }),
})

export const { useGetProfileQuery } = profileApi
